export default {
    getDetailContainer($row, key, containerIdPrefix) {
        if (!key || key.type !== 'member') return $();
        const $detailRow = this.getDetailRowDivByRowKey(key);
        const selector = `#${containerIdPrefix}-${key.id}`;
        return $detailRow.length ? $detailRow.find(selector) : $row.find(selector);
    },

    abortRequest(key) {
        const xhr = this.activeRequests[key];
        if (xhr && xhr.abort) {
            xhr.abort();
            delete this.activeRequests[key];
        }
    },

    fetchPaymentDetailList(payments, totals) {
        if (!this.detailListPartialRoute) {
            return $.Deferred().reject(new Error('detailListPartialRoute is required')).promise();
        }

        return $.ajax({
            url: this.detailListPartialRoute,
            type: 'POST',
            data: JSON.stringify({ payments: payments, totals: totals }),
            contentType: 'application/json',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        }).then(html => $(html));
    },
};
